import { render, staticRenderFns } from "./FaturaPix.vue?vue&type=template&id=68f7054e&scoped=true&"
import script from "./FaturaPix.vue?vue&type=script&lang=js&"
export * from "./FaturaPix.vue?vue&type=script&lang=js&"
import style0 from "./FaturaPix.vue?vue&type=style&index=0&id=68f7054e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7054e",
  null
  
)

export default component.exports